import { WhatsAppAppointmentButton } from './WhatsAppAppointmentButton'
import { ContactVerification } from './ContactVerification'
import { SocialMediaLink } from './SafeExternalLink'


interface FooterProps {
  dictionary: {
    navigation: {
      home: string;
      aboutUs: string;
      services: string;
      developmentalConditions: string;
      testimonials: string;
      resources: string;
      contact: string;
    };
  };
}

// Array de especialistas para el footer
const especialistasFooter = [
  {
    id: "monica-vargas-neuropsicologa",
    nombre: "MSc. Mónica Vargas Oviedo",
    especialidad: "Neuropsicóloga Pediátrica"
  },
  {
    id: "jacqueline-alfaro-psicologa-psicopedagoga",
    nombre: "MSc. Jacqueline Alfaro",
    especialidad: "Psicóloga"
  },
  {
    id: "gina-olivera-terapeuta-lenguaje",
    nombre: "Lic. Gina Olivera Sandoval",
    especialidad: "Terapeuta del Lenguaje"
  },
  {
    id: "laura-vargas-terapeuta-ocupacional",
    nombre: "Lic. Laura Vargas Vallejos",
    especialidad: "Terapeuta Ocupacional - Integradora Sensorial"
  },
  {
    id: "sofia-mena-terapeuta-ocupacional",
    nombre: "Lic. Sofia Mena Fernandez",
    especialidad: "Terapeuta Ocupacional - Integradora Sensorial"
  },
  {
    id: "andrea-rodriguez-psiquiatra",
    nombre: "Dra. Andrea Rodríguez González",
    especialidad: "Psiquiatra"
  },
  // TEMPORALMENTE OCULTO - Dra. Bianca Brenes
  /*
  {
    id: "bianca-brenes",
    nombre: "Dra. Bianca Brenes",
    especialidad: "Médica General Infantil"
  }
  */
];

export function Footer({ dictionary }: FooterProps) {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-neuro-dark-blue text-white" role="contentinfo" aria-label="Pie de página">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10">
          {/* Logo y descripción */}
          <div className="md:col-span-1">
            <a href="/" aria-label="Neuro Peques - Ir al inicio">
              <img
                src="/images/logo-neuropeques-white.png"
                alt="Neuro Peques Logo"
                width={180}
                height={50}
                className="h-auto w-auto mb-4"
                loading="lazy"
                decoding="async"
              />
            </a>
            <p className="text-gray-300 text-sm mt-4">
              Centro integral de salud infantil en Heredia, Costa Rica. Ofrecemos neuropsicología, terapia de lenguaje, terapia ocupacional, psicología infantil, psicopedagogía y psiquiatría para población infanto-juvenil y adulta.
            </p>
            <div className="mt-6 flex space-x-4">
              <SocialMediaLink 
                href="https://facebook.com/neuropequescr"
                platform="facebook"
                className="text-white hover:text-neuro-yellow transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"></path>
                </svg>
              </SocialMediaLink>
              <SocialMediaLink 
                href="https://instagram.com/neuropequescr"
                platform="instagram"
                className="text-white hover:text-neuro-yellow transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" className="h-6 w-6" fill="currentColor">
                  <path d="M295.42,6c-53.2,2.51-89.53,11-121.29,23.48-32.87,12.81-60.73,30-88.45,57.82S40.89,143,28.17,175.92c-12.31,31.83-20.65,68.19-23,121.42S2.3,367.68,2.56,503.46,3.42,656.26,6,709.6c2.54,53.19,11,89.51,23.48,121.28,12.83,32.87,30,60.72,57.83,88.45S143,964.09,176,976.83c31.8,12.29,68.17,20.67,121.39,23s70.35,2.87,206.09,2.61,152.83-.86,206.16-3.39S799.1,988,830.88,975.58c32.87-12.86,60.74-30,88.45-57.84S964.1,862,976.81,829.06c12.32-31.8,20.69-68.17,23-121.35,2.33-53.37,2.88-70.41,2.62-206.17s-.87-152.78-3.4-206.1-11-89.53-23.47-121.32c-12.85-32.87-30-60.7-57.82-88.45S862,40.87,829.07,28.19c-31.82-12.31-68.17-20.7-121.39-23S637.33,2.3,501.54,2.56,348.75,3.4,295.42,6m5.84,903.88c-48.75-2.12-75.22-10.22-92.86-17-23.36-9-40-19.88-57.58-37.29s-28.38-34.11-37.5-57.42c-6.85-17.64-15.1-44.08-17.38-92.83-2.48-52.69-3-68.51-3.29-202s.22-149.29,2.53-202c2.08-48.71,10.23-75.21,17-92.84,9-23.39,19.84-40,37.29-57.57s34.1-28.39,57.43-37.51c17.62-6.88,44.06-15.06,92.79-17.38,52.73-2.5,68.53-3,202-3.29s149.31.21,202.06,2.53c48.71,2.12,75.22,10.19,92.83,17,23.37,9,40,19.81,57.57,37.29s28.4,34.07,37.52,57.45c6.89,17.57,15.07,44,17.37,92.76,2.51,52.73,3.08,68.54,3.32,202s-.23,149.31-2.54,202c-2.13,48.75-10.21,75.23-17,92.89-9,23.35-19.85,40-37.31,57.56s-34.09,28.38-57.43,37.5c-17.6,6.87-44.07,15.07-92.76,17.39-52.73,2.48-68.53,3-202.05,3.29s-149.27-.25-202-2.53m407.6-674.61a60,60,0,1,0,59.88-60.1,60,60,0,0,0-59.88,60.1M245.77,503c.28,141.8,115.44,256.49,257.21,256.22S759.52,643.8,759.25,502,643.79,245.48,502,245.76,245.5,361.22,245.77,503m90.06-.18a166.67,166.67,0,1,1,167,166.34,166.65,166.65,0,0,1-167-166.34" transform="translate(-2.5 -2.5)"/>
                </svg>
              </SocialMediaLink>
              <WhatsAppAppointmentButton 
                phoneNumber="50685838056"
                className="text-white hover:text-neuro-yellow transition-colors"
                message="Hola, me interesa obtener información sobre los servicios de Neuro Peques"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"></path>
                </svg>
              </WhatsAppAppointmentButton>
            </div>
          </div>

          {/* Enlaces rápidos */}
          <div className="md:col-span-1">
            <h3 className="text-lg font-bold mb-4 text-white">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="/" 
                  className="text-gray-300 hover:text-white transition-colors"
                  aria-label="Ir a la página de inicio"
                >
                  {dictionary.navigation.home}
                </a>
              </li>
              <li>
                <a 
                  href="/quienes-somos" 
                  className="text-gray-300 hover:text-white transition-colors"
                  aria-label="Conocer más sobre Neuro Peques"
                >
                  {dictionary.navigation.aboutUs}
                </a>
              </li>
              <li>
                <a 
                  href="/servicios" 
                  className="text-gray-300 hover:text-white transition-colors"
                  aria-label="Ver nuestros servicios profesionales"
                >
                  {dictionary.navigation.services}
                </a>
              </li>
              <li>
                <a 
                  href="/condiciones-del-desarrollo" 
                  className="text-gray-300 hover:text-white transition-colors"
                  aria-label="Información sobre condiciones del neurodesarrollo infantil"
                >
                  {dictionary.navigation.developmentalConditions}
                </a>
              </li>
              {/* TEMPORALMENTE OCULTO - Testimonios (será habilitado cuando tengamos información real)
              <li>
                <a 
                  href="/testimonios" 
                  className="text-gray-300 hover:text-white transition-colors"
                  aria-label="Leer testimonios de nuestros pacientes"
                >
                  {dictionary.navigation.testimonials}
                </a>
              </li>
              */}
              <li>
                <a 
                  href="/contacto" 
                  className="text-gray-300 hover:text-white transition-colors"
                  aria-label="Contactar con Neuro Peques"
                >
                  {dictionary.navigation.contact}
                </a>
              </li>
            </ul>
          </div>

          {/* Especialistas */}
          <div className="md:col-span-1">
            <h3 className="text-lg font-bold mb-4 text-white">Nuestras Especialistas</h3>
            <ul className="space-y-3">
              {especialistasFooter.map((especialista) => (
                <li key={especialista.id} className="text-sm">
                  <a 
                    href={`/especialistas/${especialista.id}`}
                    className="block hover:text-neuro-yellow transition-colors"
                    aria-label={`Ver perfil de ${especialista.nombre}`}
                  >
                    <div className="font-semibold text-white hover:text-neuro-yellow">{especialista.nombre}</div>
                    <div className="text-gray-300">{especialista.especialidad}</div>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Servicios */}
          <div className="md:col-span-1">
            <h3 className="text-lg font-bold mb-4 text-white">Servicios</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a 
                  href="/servicios/neuropsicologia-infantil" 
                  className="text-gray-300 hover:text-neuro-yellow transition-colors"
                  aria-label="Ver servicio de Neuropsicología Infantil"
                >
                  Neuropsicología Infantil
                </a>
              </li>
              <li>
                <a 
                  href="/servicios/terapia-de-lenguaje" 
                  className="text-gray-300 hover:text-neuro-yellow transition-colors"
                  aria-label="Ver servicio de Terapia de Lenguaje"
                >
                  Terapia de Lenguaje
                </a>
              </li>
              <li>
                <a 
                  href="/servicios/terapia-ocupacional" 
                  className="text-gray-300 hover:text-neuro-yellow transition-colors"
                  aria-label="Ver servicio de Terapia Ocupacional"
                >
                  Terapia Ocupacional
                </a>
              </li>
              <li>
                <a 
                  href="/servicios/psicologia-infantil" 
                  className="text-gray-300 hover:text-neuro-yellow transition-colors"
                  aria-label="Ver servicio de Psicología Infantil"
                >
                  Psicología Infantil
                </a>
              </li>
              <li>
                <a 
                  href="/servicios/psicopedagogia" 
                  className="text-gray-300 hover:text-neuro-yellow transition-colors"
                  aria-label="Ver servicio de Psicopedagogía"
                >
                  Psicopedagogía
                </a>
              </li>
              <li>
                <a 
                  href="/servicios/psiquiatria-pediatrica" 
                  className="text-gray-300 hover:text-neuro-yellow transition-colors"
                  aria-label="Ver servicio de Psiquiatría"
                >
                  Psiquiatría
                </a>
              </li>
              {/* TEMPORALMENTE OCULTO - Medicina General Infantil
              <li>
                <a 
                  href="/servicios/medicina-general-infantil" 
                  className="text-gray-300 hover:text-neuro-yellow transition-colors"
                  aria-label="Ver servicio de Medicina General Infantil"
                >
                  Medicina General Infantil
                </a>
              </li>
              */}
            </ul>
          </div>

          {/* Contacto */}
          <div className="md:col-span-1">
            <h3 className="text-lg font-bold mb-4 text-white">Contacto</h3>
            <div className="space-y-4">
              <div itemScope itemType="https://schema.org/MedicalClinic">
                <div className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                    <p className="text-gray-300">
                      <span itemProp="streetAddress">5to piso de la Torre de Negocios del Mall Paseo de las Flores</span><br />
                      <span itemProp="addressLocality">Heredia</span>,&nbsp;
                      <span itemProp="postalCode">40101</span><br />
                      <span itemProp="addressCountry">Costa Rica</span>
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="flex items-start">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <div>
                  <ContactVerification 
                    type="phone" 
                    value="+50685838056"
                    className="text-gray-300 hover:text-white transition-colors block cursor-pointer"
                  >
                    <span aria-label="Llamar al teléfono principal" itemProp="telephone">
                      +506 8583-8056
                    </span>
                  </ContactVerification>
                </div>
              </div>
              
              <div className="flex items-start">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <div>
                  <ContactVerification 
                    type="email" 
                    value="info@neuropequescr.com"
                    className="text-gray-300 hover:text-white transition-colors block cursor-pointer"
                  >
                    <span aria-label="Enviar correo electrónico" itemProp="email">
                      info@neuropequescr.com
                    </span>
                  </ContactVerification>
                  <ContactVerification 
                    type="email" 
                    value="citas@neuropequescr.com"
                    className="text-gray-300 hover:text-white transition-colors block cursor-pointer"
                  >
                    <span aria-label="Solicitar cita por correo">
                      citas@neuropequescr.com
                    </span>
                  </ContactVerification>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Línea divisoria */}
        <hr className="border-gray-700 my-8" />

        {/* Pie de página inferior */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
            <p className="text-gray-400 text-sm">
              &copy; {currentYear} Neuro Peques. Todos los derechos reservados.
            </p>
            <div className="text-xs text-gray-400">
              <span>Contenido por: </span>
              <a 
                href="/especialistas/monica-vargas"
                className="text-neuro-yellow hover:text-white transition-colors"
              >
                MSc. Mónica Vargas Oviedo
              </a>
              {' '}- Directora de Neuro Peques
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
